export function convertLabelTextToDataTestId(string, prefix, suffix) {
    const stringWithPrefix = prefix ? prefix.concat(" ", string) : string
    const stringWithPrefixAndSuffix = suffix ? stringWithPrefix.concat(" ", suffix) : stringWithPrefix

    return stringWithPrefixAndSuffix.replace(/\s/g, '-')
        .replace(/:/g, '')
        .replace(/--/g, '-')
        .replace(/-_/g, '_')
        .toLowerCase()
}
